import { useMemo } from 'react';
import {
  calculateGlobalLandedCost,
  inferCategorySlug,
} from '../services/globalFinancialEngineCore';

/**
 * Recompute cart line totals when destination country changes (client-side global engine).
 */
export function useGlobalCartPricing(cart, destinationCountry) {
  return useMemo(() => {
    if (!cart?.items?.length) return cart;

    let total = 0;
    const items = cart.items.map((item) => {
      const sourcePrice =
        Number(item.source_price) ||
        Number(item.concierge_breakdown?.original_cost) ||
        Number(item.global_pricing?.rawMarketplaceCostUSD) ||
        0;

      if (!(sourcePrice > 0)) {
        total += Number(item.item_total) || 0;
        return item;
      }

      const global = calculateGlobalLandedCost({
        rawMarketplacePrice: sourcePrice,
        weightLbs: item.estimated_weight_lbs || item.concierge_breakdown?.weight_lbs || 0.5,
        destinationCountry,
        categorySlug: inferCategorySlug(item.name || item.item_title || '', item.category_slug),
      });

      const landed = global.priceUSD;
      const qty = Number(item.quantity) || 1;
      const itemTotal = round2(landed * qty);
      total += itemTotal;

      return {
        ...item,
        landed_price: landed,
        landed_price_usd: landed,
        calculated_landed_price: landed,
        item_total: itemTotal,
        global_pricing: global,
        concierge_breakdown: {
          ...(item.concierge_breakdown || {}),
          original_cost: sourcePrice,
          calculated_landed_price: landed,
          pricing_engine: 'global_failsafe',
          global_pricing: global,
        },
        pricing_model: 'global_failsafe',
        local_currency: global.localCurrency,
        local_landed_total: global.paymentPayloadLocalCurrency?.grandTotalLanded,
      };
    });

    return {
      ...cart,
      items,
      total: round2(total),
      destination: destinationCountry,
      pricing_engine: 'global_failsafe',
    };
  }, [cart, destinationCountry]);
}

function round2(n) {
  return Math.round(Number(n) * 100) / 100;
}
